var $ = require('jquery');

var Navigation = function() {

	function init() {
		$('.show-menu-btn').on('click', showMenu);
		$('.close-menu-btn').on('click', closeMenu);
	}

	function showMenu(e) {
        e.preventDefault();
		$('.mobile-menu').addClass('open');
	}

	function closeMenu(e) {
		e.preventDefault();
		$('.mobile-menu').removeClass('open');
	}

	init();

};

module.exports = Navigation;